import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PERMISSION_ORDER } from '../../../constants/permissionConstants';
import { Role } from '../../../interfaces/RoleManagementInterfaces';

export const useEditRole = (
  userRole: Role,
  onSubmit: (updatedRole: Role) => void,
  onCancel: () => void
) => {
  const [selectedPermission, setSelectedPermission] = useState<string[]>(userRole.permissions);
  const [validationError, setValidationError] = useState<string>('');
  const { t } = useTranslation();

  const handleSubmit = () => {
    if (selectedPermission.length === 0) {
      setValidationError(t('empty-permissions-error'));
      return;
    }

    const permissionsChanged =
      selectedPermission.length !== userRole.permissions.length ||
      !selectedPermission.every((perm) => userRole.permissions.includes(perm));

    if (!permissionsChanged) {
      onCancel();
      return;
    }

    setValidationError('');
    onSubmit({ ...userRole, permissions: selectedPermission });
  };

  const handlePermissions = (
    event: React.ChangeEvent<HTMLInputElement>,
    permission: { id: string; label: string }
  ) => {
    let updatedPermissions: string[];
    if (event.target.checked) {
      updatedPermissions = [...selectedPermission, permission.label];
    } else {
      updatedPermissions = selectedPermission.filter((item) => item !== permission.label);
    }
    const orderedPerms = PERMISSION_ORDER.filter((perm) => updatedPermissions.includes(perm));
    setSelectedPermission(orderedPerms);
  };

  return { selectedPermission, validationError, handleSubmit, handlePermissions };
};
